import { render } from "./PanelsComponent.vue?vue&type=template&id=30e7bcea&scoped=true"
import script from "./PanelsComponent.vue?vue&type=script&lang=js"
export * from "./PanelsComponent.vue?vue&type=script&lang=js"

import "./PanelsComponent.vue?vue&type=style&index=0&id=30e7bcea&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e7bcea"]])

export default __exports__